module.exports = __webpack_public_path__ + "img/example_4_icon.08de5a77.png";